const fetchData = async (url) => {
  // Fetch data from specified url
  const response = await fetch(url);
  // Parse json data
  const data = await response.json();
  return data;
};

export default fetchData;
